import React, { useRef, useState } from 'react'
import Modal from 'react-modal';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 999999,
        width: "60vw"
    },
};
Modal.setAppElement('#modal');
const Information = ({detail}) => {
    let subtitle;
    const [modalIsOpen, setIsOpen] = useState(false);
    const [done, setDone] = useState(false);

    if (done) {
        MySwal.fire({
            title: <strong>Thank you very much</strong>,
            html: <i>You messag sent successfully!</i>,
            icon: 'success',
            timer: 2500
        })
    }

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_rqa4g65', 'template_rvtpfop', form.current, 'user_bRkHMxkuI6kokvr9UdtEL')
            .then((result) => {
                console.log(result.text);
                setDone(true)
                closeModal()
            }, (error) => {
                console.log(error.text);
            });
    };


    return (
        <div className="info">
            <h1 className="fullname">{detail?.fullname}</h1>
            <h3 className="speciality">{detail?.speciality}</h3>
            <ul className="social-media">
                <li><a href={detail?.facebook} target="_blank" rel="noreferrer"><i className="fab fa-facebook"></i></a></li>
                <li><a href={detail?.phone} target="_blank" rel="noreferrer"><i className="fas fa-mobile-alt"></i></a></li>
                <li><a href={detail?.twitter} target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a></li>
                <li><a href={detail?.telegram} target="_blank" rel="noreferrer"><i className="fab fa-telegram"></i></a></li>
                <li><a href={detail?.whatsapp} target="_blank" rel="noreferrer"><i className="fab fa-whatsapp"></i></a></li>
                <li><a href={detail?.skype} target="_blank" rel="noreferrer"><i className="fab fa-skype"></i></a></li>
                <li><a href={detail?.github} target="_blank" rel="noreferrer"><i className="fab fa-github"></i></a></li>
                <li><a href="#" onClick={openModal}><i className="fas fa-envelope"></i></a></li>
            </ul>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Send Message"
            >
                <div className="header">
                    <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Send Message</h2>
                    <button onClick={closeModal}>&#10761;</button>
                </div>
                <form className="sendForm" ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                        <label>Name</label>
                        <input type="text" placeholder="Full name" required name="user_name" />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" placeholder="Email" required name="user_email" />
                    </div>
                    <div className="form-group">
                        <label>Message</label>
                        <textarea name="message" rows="5" placeholder="Your message" />
                    </div>
                    <input className="sendBtn" type="submit" value="Send" />
                </form>
            </Modal>

        </div>
    )
}

export default Information
